;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import type { PropertyVisibilityFilter } from "@/types/property";

/**
 * Valid visibility filter values (title case to match DB values)
 */
const VALID_VISIBILITY_VALUES: PropertyVisibilityFilter[] = [
	"Active",
	"Hidden",
	"All",
];

/**
 * Parse a visibility query parameter value into a PropertyVisibilityFilter.
 *
 * @param value - The raw query param value (may be null/undefined/invalid)
 * @returns The parsed visibility filter, or undefined if invalid/missing
 *
 * @remarks
 * - Returns `undefined` for missing/invalid values (caller treats as "All")
 * - Accepts title-case values: "Active", "Hidden", "All"
 */
export function parsePropertyVisibility(
	value: string | null | undefined,
): PropertyVisibilityFilter | undefined {
	if (!value) return undefined;

	// Check if value is a valid visibility filter
	if (VALID_VISIBILITY_VALUES.includes(value as PropertyVisibilityFilter)) {
		return value as PropertyVisibilityFilter;
	}

	return undefined;
}

/**
 * Normalize visibility for URL params and query keys.
 *
 * @param visibility - The visibility filter value
 * @returns The visibility value to use, or undefined if "All" (to omit from URL)
 *
 * @remarks
 * Returns undefined for "All" so it can be omitted from URL params,
 * since "All" is the default behavior.
 */
export function normalizeVisibilityForUrl(
	visibility: PropertyVisibilityFilter | undefined,
): PropertyVisibilityFilter | undefined {
	if (!visibility || visibility === "All") {
		return undefined;
	}
	return visibility;
}
